import { render } from "./BTCProduction.vue?vue&type=template&id=790cd0a3"
import script from "./BTCProduction.vue?vue&type=script&lang=js"
export * from "./BTCProduction.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__